import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCaretUp = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 12,
	height: 8,
	viewBox: "0 0 12 8",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M11.0391 7.30151C11.3516 7.30151 11.5859 7.14526 11.7422 6.83276C11.8594 6.52026 11.8203 6.20776 11.5859 5.97339L6.54687 0.934326C6.39062 0.778076 6.1953 0.699951 5.99999 0.699951C5.76562 0.699951 5.60937 0.778076 5.45312 0.934326L0.414054 5.97339C0.179679 6.20776 0.101554 6.52026 0.257804 6.83276C0.374992 7.14526 0.609367 7.30151 0.960929 7.30151H11.0391Z",
		fill: "currentColor"
	})
});
export default SvgCaretUp;
